import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/profile`;

export class Profile {
  static async fetchProfile(params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchDictionary(dictionaryId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/${dictionaryId}`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async createOrUpdateDictionary(dictionaryId, data, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(`${BASE_URL}/${dictionaryId}`, data, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchCategory(dictionaryId, categoryId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/${dictionaryId}/${categoryId}`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async createOrUpdateCategory(dictionaryId, categoryId, data, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(
        `${BASE_URL}/${dictionaryId}/${categoryId}`,
        data,
        {
          headers: {
            ...Contexture.getHeaders(profileId),
            'Content-Type': 'application/json',
          },
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchPrefilters(params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/prefilters`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async createOrUpdatePrefilters(data, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(`${BASE_URL}/prefilters`, data, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchCustomTerms(params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/customterms`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async createOrUpdateCustomTerms(data, params) {
    try {
      const profileId = data?.profileId || params?.profileId;
      const response = await axios.post(`${BASE_URL}/customterms`, data, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchTags(params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/tags`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async createOrUpdateTags(data, params) {
    try {
      const profileId = data?.profileId || params?.profileId;
      const response = await axios.post(`${BASE_URL}/tags`, data, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async createProfile(data, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(`${BASE_URL}/create_profile`, data, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getRecommendationParameters(params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/recommendation_parameters`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async setRecommendationParameters(data, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(`${BASE_URL}/recommendation_parameters`, data, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
